import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { selectDataSourcesByCountry, State as DataSourceState } from '~/MedicinalBrandsAnalytics/DataSource';
import {
	RegionAvailability,
	selectRegionAvailabilities,
	State as RegionState,
} from '~/MedicinalBrandsAnalytics/Region';

import AvailabilityList from './AvailabilityList';

interface State {
	medicinalBrandsAnalyticsRegion: RegionState;
	medicinalBrandsAnalyticsDataSource: DataSourceState;
}

const memoizedSelectRegionAvailabilities = memoizeOne((regionState, dataSourceState) => {
	return selectRegionAvailabilities(regionState, selectDataSourcesByCountry(dataSourceState.dataSources || []));
});

function mapStateToProps({ medicinalBrandsAnalyticsRegion, medicinalBrandsAnalyticsDataSource }: State): {
	regionAvailabilities: RegionAvailability[] | null;
} {
	return {
		regionAvailabilities: memoizedSelectRegionAvailabilities(
			medicinalBrandsAnalyticsRegion,
			medicinalBrandsAnalyticsDataSource
		),
	};
}

export default connect(mapStateToProps)(AvailabilityList);
